import React, { Component } from "react";
import { Row, Card, CardBody } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Logs from "../../../containers/dashboards/Logs";
import StockStatus from "../../../containers/dashboards/StockStatus";
import SalesChartCard from "../../../containers/dashboards/SalesChartCard";

import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  NotificatioErrController,
  NotificatioSucController,
  getCurrentDate,
  AddCommaNumber,
} from "../../../helpers/Utils";import createSocket from "../../../helpers/createSocket";
import { ThemeColors } from "../../../helpers/ThemeColors";
import IntlMessages from "../../../helpers/IntlMessages";
import { injectIntl } from "react-intl";
import { ContentMini } from "../../../components/preloader";
import moment from "moment";
import { isRorRBDorRC } from "../../../helpers/Roles";
import classnames from "classnames";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import {
  OutcomeTable,
  IncomeTable,
  StockLogTable,
  DebtTable,
  MakeProductTable,
  OrderTable,
  Heading,
  TotalCount,
  PaymentMethodTable,
  TopProductsTable,
  CustomerAnalytics,
  BookingAnalytics,
  ProductCustomerDrawer,
} from "../../../containers/pages/analytics";
import StaffAnalytics from "../../../containers/pages/analytics/StaffAnalytics";

const colors = ThemeColors();

function collect(props) {
  return { data: props.data };
}

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      license: false,

      setting: {
        compare: false,
        all: false,
        date_start: moment(),
        date_end: moment(),

        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateLabel: this.props.intl.formatMessage({
          id: "analytics.filter.today",
        }),
      },

      license: {},
      hide_button_add: false,

      data_outcome: {
        data: [],
        loading: true,
      },
      data_income: {
        data: [],
        loading: true,
      },
      data_order_payment: {
        data: [],
        loading: true,
      },
      data_stock_log: {
        data: [],
        loading: true,
      },
      data_debt: {
        data: [],
        loading: true,
      },
      data_make_product: {
        data: [],
        loading: true,
      },
      data_order_table: {
        data: [],
        loading: true,
      },
      data_payment_method: {
        data: [],
        loading: true,
      },
      data_top_products: {
        data: [],
        loading: true,
      },
      data_top_selling_products: {
        data: [],
        loading: true,
        summary: {
          total_products_sold: 0,
          total_quantity_sold: 0,
          total_revenue: 0,
          total_cost: 0,
          total_gross_profit: 0,
          avg_profit_margin: 0,
        },
      },
      data_customer: {
        new_customers: { count: 0, data: [] },
        returning_customers: { count: 0, data: [] },
        top_spenders: { count: 0, total_spent: 0, data: [] },
        summary: {
          total_customers: 0,
          total_new: 0,
          total_returning: 0,
          total_spent: 0,
          total_debt: 0,
        },
        loading: true,
      },
      data_log: {
        data: [],
        loading: true,
      },
      data_staff: {
        summary: {},
        all_time_summary: {},
        data: [],
        loading: true,
      },
      data_booking: {
        stats: {},
        data: [],
        loading: true,
      },
      data_stock: {
        data: [],
        loading: true,
      },
      data_pnl_details: {
        totalDiscount: 0,
        totalTax: 0,
        totalFee: 0,
        grossRevenue: 0,
        netRevenue: 0,
        loading: true,
      },
      data_chart: {
        loading: true,
        labels: [],
        report: {
          dates: [],
          datas: [],
        },
        datasets: [
          {
            label: this.props.intl.formatMessage({
              id: "analytics.chart.income",
            }),
            data: [],
            borderColor: colors.themeColor1,
            pointBackgroundColor: colors.foregroundColor,
            pointBorderColor: colors.themeColor1,
            pointHoverBackgroundColor: colors.themeColor1,
            pointHoverBorderColor: colors.foregroundColor,
            pointRadius: 6,
            pointBorderWidth: 2,
            pointHoverRadius: 8,
            fill: false,
            fileName: "Report",
          },
          {
            label: this.props.intl.formatMessage({
              id: "analytics.chart.outcome",
            }),
            data: [],
            borderColor: "rgba(220,220,220,1)",
            pointBackgroundColor: colors.foregroundColor,
            pointBorderColor: "rgba(220,220,220,1)",
            pointHoverBackgroundColor: "rgba(220,220,220,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointRadius: 6,
            pointBorderWidth: 2,
            pointHoverRadius: 8,
            fill: false,
            fileName: "Report",
          },
        ],
      },
      data_companies: {
        data: [],
        loading: true,
        selected: "null",
      },
      stocks: {
        data: [],
      },
      products: {
        data: [],
      },

      // Tab navigation
      activeTab: "overview", // overview, products, materials, debt, payment, customers, staff
      selectedBuyerProduct: null,
    };
    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    this.socket.on("refresh-stock", (res) => {
      const data = res?.data?.data;
      if (Array.isArray(data)) {
        this.setState((prev) => ({
          ...prev,
          data_stock: {
            loading: false,
            data: data,
          },
        }));
      }
    });

    this.socket.on("analytics chart", (res) => {
      if (!res?.data) return;
      let cloneObj = Object.assign({}, this.state.data_chart);
      cloneObj.loading = false;
      cloneObj.labels = res.data.labels || [];
      cloneObj.report.dates = res.data.labels || [];
      cloneObj.report.income = res.data.income || [];
      cloneObj.report.outcome = res.data.outcome || [];
      cloneObj.datasets[0].data = res.data.income || [];
      cloneObj.datasets[0].label = this.props.intl.formatMessage({
        id: "analytics.chart.income",
      });
      cloneObj.datasets[1].data = res.data.outcome || [];
      cloneObj.datasets[1].label = this.props.intl.formatMessage({
        id: "analytics.chart.outcome",
      });

      this.setState((prev) => ({
        ...prev,
        data_chart: cloneObj,
      }));
    });

    this.onUpdateData();
    this.getLicense();
  }

  getLicense = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/user-license"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        let user_license = data.data;

        let currentDate = getCurrentDate();

        if (user_license.expired_date < currentDate && !user_license.upgraded) {
          this.setState((prev) => ({
            license: {
              using: false,
              purchased_package: user_license.purchased_package,
            },
          }));
        } else {
          this.setState((prev) => ({
            license: {
              using: true,
              purchased_package: user_license.purchased_package,
            },
          }));
        }

        this.hideButtonAdd();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };

  openProductCustomers = (product) => {
    if (!product || !product.id) return;
    this.setState({ activeTab: "products", selectedBuyerProduct: product });
  };

  closeProductCustomers = () => this.setState({ selectedBuyerProduct: null });

  hideButtonAdd = () => {
    let { license } = this.state;

    if (
      license.using === false ||
      String(license.purchased_package).toUpperCase() === "FREE"
    ) {
      return this.setState({
        hide_button_add: true,
      });
    } else {
      return this.setState({
        hide_button_add: false,
      });
    }
  };

  onUpdateData = async () => {
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    this.socket.emit("refresh-stock", {
      user_id: localStorage.getItem("user_id"),
      company_uuid: selected,
    });

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    this.socket.emit("analytics chart", {
      user_id: localStorage.getItem("user_id"),
      all,
      date_start: _date_start,
      date_end: _date_end,
      company_uuid: selected,
    });

    this.dataCompanies();
    this.dataLog();
    this.dataOutcome();
    this.dataIncome();
    this.dataOrderPayment();
    this.dataStockLog();
    this.dataDebt();
    this.dataMakeProduct();
    this.dataOrderTable();
    this.dataPaymentMethod();
    this.dataTopProducts();
    this.dataTopSellingProducts();
    this.dataCustomer();
    this.dataStaff();
    this.dataBooking();
    this.dataStocks();
    this.dataProducts();
    this.dataPnlDetails();
  };

  /** Func Helper */
  dataCompanies = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/companies/child"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((res) => {
        const first_value = {
          label: this.props.intl.formatMessage({
            id: "analytics.filter.my_store",
          }),
          value: "null",
        };

        const last_value = {
          label: this.props.intl.formatMessage({ id: "analytics.filter.all" }),
          value: "all",
        };

        let data = [];
        data.push(first_value);
        data = data.concat(res.data);

        if (res.data.length) {
          data.push(last_value);
        }

        this.setState((prev) => ({
          ...prev,
          data_companies: {
            ...prev.data_companies,
            loading: false,
            data: data,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.agency" }),
        );
        return false;
      });
  };
  dataLog = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/log?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_log: {
            loading: false,
            data: res.data,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.activity" }),
        ),
      );
  };
  dataOutcome = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/outcome?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_outcome: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_count: res.data.total_count,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.outcome" }),
        ),
      );
  };
  dataIncome = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/income?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_income: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_count: res.data.total_count,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.income" }),
        ),
      );
  };
  dataOrderPayment = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/order?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_order_payment: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_count: res.data.total_count,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({
            id: "analytics.error.sold_products",
          }),
        ),
      );
  };
  dataStockLog = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/stock-log?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        // console.log(res);
        return this.setState((prev) => ({
          ...prev,
          data_stock_log: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            summary: res.data.summary,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({
            id: "analytics.error.material_import",
          }),
        ),
      );
  };
  dataDebt = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/debt?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_debt: {
            loading: false,
            data: res.data.data,
            total_price_income: res.data.total_price_income,
            total_price_pending: res.data.total_price_pending,
            total_count: res.data.total_count,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.debt" }),
        ),
      );
  };
  dataMakeProduct = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/make-product?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_make_product: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({
            id: "analytics.error.material_usage",
          }),
        ),
      );
  };
  dataOrderTable = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/table?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        // console.log('data: ', res.data.data);
        return this.setState((prev) => ({
          ...prev,
          data_order_table: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_discount: res.data.total_discount,
            total_count: res.data.total_count,
            total_gift_count: res.data.total_gift_count,
            total_table_has_guest: res.data.total_table_has_guest,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.table" }),
        ),
      );
  };
  dataPaymentMethod = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/payment-method?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        return this.setState((prev) => ({
          ...prev,
          data_payment_method: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_count: res.data.total_count,
            total_product_count: res.data.total_product_count,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({
            id: "analytics.error.payment_method",
          }),
        ),
      );
  };
  dataTopProducts = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/top-products?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        return this.setState((prev) => ({
          ...prev,
          data_top_products: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_count: res.data.total_count,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.top_products" }),
        ),
      );
  };

  dataTopSellingProducts = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/top-selling-products?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        return this.setState((prev) => ({
          ...prev,
          data_top_selling_products: {
            loading: false,
            data: res.data.data,
            total_price: res.data.total_price,
            total_count: res.data.total_count,
            summary: res.data.summary,
            compare_total: res.data.compare_total,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.best_selling" }),
        ),
      );
  };

  dataCustomer = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/customer?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        return this.setState((prev) => ({
          ...prev,
          data_customer: {
            loading: false,
            new_customers: res.data.new_customers,
            returning_customers: res.data.returning_customers,
            top_spenders: res.data.top_spenders,
            summary: res.data.summary,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.customer" }),
        ),
      );
  };

  dataStaff = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/staff?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        return this.setState((prev) => ({
          ...prev,
          data_staff: {
            loading: false,
            summary: res.data.summary,
            all_time_summary: res.data.all_time_summary,
            data: res.data.data,
          },
        }));
      })
      .catch((err) =>
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.staff" }),
        ),
      );
  };

  dataBooking = () => {
    const businessType = localStorage.getItem("businessType");
    // Only fetch booking data for cafe and restaurant
    if (businessType !== "cafe" && businessType !== "restaurant") {
      return this.setState((prev) => ({
        ...prev,
        data_booking: {
          loading: false,
          stats: {},
          data: [],
        },
      }));
    }

    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(
        `${END_POINT}/analytics/booking?all=${all}&compare=${compare}&date_start=${_date_start}&date_end=${_date_end}&company_uuid=${selected}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((res) => {
        return this.setState((prev) => ({
          ...prev,
          data_booking: {
            loading: false,
            stats: res.data.stats,
            data: res.data.data,
          },
        }));
      })
      .catch((err) =>
        console.log(
          this.props.intl.formatMessage({ id: "analytics.error.booking" }),
        ),
      );
  };

  dataStocks = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/stock/all-unit"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        // console.log(data);
        this.setState((prev) => ({
          ...prev,
          stocks: {
            data: data.data,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "analytics.error.materials" }),
        );
      });
  };

  dataProducts = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/product/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          products: {
            data: data.data,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataPnlDetails = () => {
    let tokenStr = localStorage.getItem("access_token");
    const { all, compare, date_start, date_end } = this.state.setting;
    const { selected } = this.state.data_companies;

    let _date_start = moment(date_start).clone().format("YYYY-MM-DD");
    let _date_end = moment(date_end).clone().format("YYYY-MM-DD");

    axios
      .get(`${END_POINT + "/analytics/pnl-details"}`, {
        params: {
          all,
          compare,
          date_start: _date_start,
          date_end: _date_end,
          company_uuid: selected,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((result) => {
        const data = result.data || {};
        this.setState((prev) => ({
          ...prev,
          data_pnl_details: {
            totalDiscount: data.totalDiscount || 0,
            totalTax: data.totalTax || 0,
            totalFee: data.totalFee || 0,
            grossRevenue: data.grossRevenue || 0,
            netRevenue: data.netRevenue || 0,
            loading: false,
          },
        }));
      })
      .catch((err) => {
        console.error("Error fetching P&L details:", err);
        this.setState((prev) => ({
          ...prev,
          data_pnl_details: {
            ...prev.data_pnl_details,
            loading: false,
          },
        }));
      });
  };

  /** Func */
  onToggleSetting = (_name, _value) => {
    this.setState((prev) => ({
      ...prev,
      setting: {
        ...prev.setting,
        [_name]: _value,
      },
    }));
  };

  onChangeDate = ({ date_start, date_end, all }) => {
    this.setState(
      (prev) => ({
        ...prev,
        setting: {
          ...prev.setting,
          date_start: date_start,
          date_end: date_end,
          all: all,
          compare: all == true ? false : prev.setting.compare,
        },
        data_outcome: {
          ...prev.data_outcome,
          loading: true,
        },
        data_income: {
          ...prev.data_income,
          loading: true,
        },
        data_order_payment: {
          ...prev.data_order_payment,
          loading: true,
        },
        data_stock_log: {
          ...prev.data_stock_log,
          loading: true,
        },
        data_debt: {
          ...prev.data_debt,
          loading: true,
        },
        data_make_product: {
          ...prev.data_make_product,
          loading: true,
        },
        data_order_table: {
          ...prev.data_order_table,
          loading: true,
        },
        data_customer: {
          ...prev.data_customer,
          loading: true,
        },
        data_payment_method: {
          ...prev.data_payment_method,
          loading: true,
        },
        data_log: {
          ...prev.data_log,
          loading: true,
        },
        data_stock: {
          ...prev.data_stock,
          loading: true,
        },
        data_chart: {
          ...prev.data_chart,
          loading: true,
        },
      }),
      () => this.onUpdateData(),
    );
  };

  onChangeCompanies = (selected) => {
    this.setState(
      (prev) => ({
        ...prev,
        data_outcome: {
          ...prev.data_outcome,
          loading: true,
        },
        data_income: {
          ...prev.data_income,
          loading: true,
        },
        data_order_payment: {
          ...prev.data_order_payment,
          loading: true,
        },
        data_stock_log: {
          ...prev.data_stock_log,
          loading: true,
        },
        data_debt: {
          ...prev.data_debt,
          loading: true,
        },
        data_make_product: {
          ...prev.data_make_product,
          loading: true,
        },
        data_order_table: {
          ...prev.data_order_table,
          loading: true,
        },
        data_customer: {
          ...prev.data_customer,
          loading: true,
        },
        data_log: {
          ...prev.data_log,
          loading: true,
        },
        data_stock: {
          ...prev.data_stock,
          loading: true,
        },
        data_chart: {
          ...prev.data_chart,
          loading: true,
        },
        data_companies: {
          ...prev.data_companies,
          selected: selected.value,
        },
      }),
      () => this.onUpdateData(),
    );
  };

  onChangeSetting = ({
    dateLabel,
    dateRange,
    all,
    date_start,
    date_end,
    compare,
  }) => {
    dateLabel = dateLabel == null ? this.state.setting.dateLabel : dateLabel;
    dateRange = dateRange == null ? this.state.setting.dateRange : dateRange;
    all = all == null ? this.state.setting.all : all;
    compare = compare == null ? this.state.setting.compare : compare;
    date_start =
      date_start == null ? this.state.setting.date_start : date_start;
    date_end = date_end == null ? this.state.setting.date_end : date_end;

    this.setState((prev) => ({
      ...prev,
      setting: {
        ...prev.setting,
        dateLabel,
        dateRange,
        all,
        date_start,
        date_end,
        compare,
      },
    }));
  };

  onExportExcel = () => {
    const {
      setting,
      data_outcome,
      data_income,
      data_order_payment,
      data_payment_method,
      data_top_products,
      data_debt,
      data_customer,
      data_stock_log,
      data_make_product,
      data_order_table,
      data_stock,
      stocks,
    } = this.state;

    // Create workbook
    const wb = XLSX.utils.book_new();

    // Helper to format data for Excel
    const formatData = (data, columns) => {
      return data.map((item) => {
        const row = {};
        columns.forEach((col) => {
          row[col.header] = col.formatter ? col.formatter(item[col.key], item) : item[col.key];
        });
        return row;
      });
    };

    // Add Outcome sheet
    if (data_outcome.data && data_outcome.data.length > 0) {
      const outcomeData = formatData(data_outcome.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.name",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.total_price",
          }),
          key: "price",
        },
      ]);
      const ws1 = XLSX.utils.json_to_sheet(outcomeData);
      XLSX.utils.book_append_sheet(
        wb,
        ws1,
        this.props.intl.formatMessage({ id: "analytics.dashboards.outcome" }),
      );
    }

    // Add Income sheet
    if (data_income.data && data_income.data.length > 0) {
      const incomeData = formatData(data_income.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.name",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.total_price",
          }),
          key: "price",
        },
      ]);
      const ws2 = XLSX.utils.json_to_sheet(incomeData);
      XLSX.utils.book_append_sheet(
        wb,
        ws2,
        this.props.intl.formatMessage({ id: "analytics.dashboards.income" }),
      );
    }

    // Add Order Payment sheet
    if (data_order_payment.data && data_order_payment.data.length > 0) {
      const orderData = formatData(data_order_payment.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.product",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.revenue",
          }),
          key: "price",
        },
      ]);
      const ws3 = XLSX.utils.json_to_sheet(orderData);
      XLSX.utils.book_append_sheet(
        wb,
        ws3,
        this.props.intl.formatMessage({
          id: "analytics.export.sheet.sold_products",
        }),
      );
    }

    // Add Payment Method sheet
    if (data_payment_method.data && data_payment_method.data.length > 0) {
      const paymentData = formatData(data_payment_method.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.method",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.order_count",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.total_price",
          }),
          key: "price",
        },
      ]);
      const ws4 = XLSX.utils.json_to_sheet(paymentData);
      XLSX.utils.book_append_sheet(
        wb,
        ws4,
        this.props.intl.formatMessage({ id: "analytics.table.payment_method" }),
      );
    }

    // Add Slow Selling Products sheet
    if (data_top_products.data && data_top_products.data.length > 0) {
      const topData = formatData(data_top_products.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.product",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.revenue",
          }),
          key: "price",
        },
      ]);
      const ws5 = XLSX.utils.json_to_sheet(topData);
      XLSX.utils.book_append_sheet(
        wb,
        ws5,
        this.props.intl.formatMessage({ id: "analytics.table.top_slow" }),
      );
    }

    // Add Debt sheet
    if (data_debt.data && data_debt.data.length > 0) {
      const debtData = formatData(data_debt.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.supplier",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.total_price",
          }),
          key: "price",
        },
      ]);
      const ws6 = XLSX.utils.json_to_sheet(debtData);
      XLSX.utils.book_append_sheet(
        wb,
        ws6,
        this.props.intl.formatMessage({ id: "analytics.tabs.debt" }),
      );
    }

    // Add Top Spenders sheet
    if (
      data_customer.top_spenders?.data &&
      data_customer.top_spenders.data.length > 0
    ) {
      const spenderData = formatData(data_customer.top_spenders.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.customer",
          }),
          key: "name",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.phone",
          }),
          key: "phone",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.order_count",
          }),
          key: "order_count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.spent",
          }),
          key: "total_spent",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.created_at",
          }),
          key: "createdAt",
          formatter: (val) => val ? moment(val).format("HH:mm DD/MM/YYYY") : "-",
        },
      ]);
      const ws7 = XLSX.utils.json_to_sheet(spenderData);
      XLSX.utils.book_append_sheet(
        wb,
        ws7,
        this.props.intl.formatMessage({
          id: "analytics.export.sheet.top_spenders",
        }),
      );
    }

    // Add Stock Log sheet (Thống kê nguyên liệu nhập)
    if (data_stock_log.data && data_stock_log.data.length > 0) {
      const stockLogData = formatData(data_stock_log.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.material",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.unit",
          }),
          key: "unit",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.total_price",
          }),
          key: "price",
        },
      ]);
      const ws8 = XLSX.utils.json_to_sheet(stockLogData);
      XLSX.utils.book_append_sheet(
        wb,
        ws8,
        this.props.intl.formatMessage({
          id: "analytics.export.sheet.imported_materials",
        }),
      );
    }

    // Add Make Product sheet (Nguyên liệu sử dụng)
    if (data_make_product.data && data_make_product.data.length > 0) {
      const makeProductData = formatData(data_make_product.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.material",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.quantity",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.unit",
          }),
          key: "unit",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.total_price",
          }),
          key: "price",
        },
      ]);
      const ws9 = XLSX.utils.json_to_sheet(makeProductData);
      XLSX.utils.book_append_sheet(
        wb,
        ws9,
        this.props.intl.formatMessage({
          id: "analytics.export.sheet.used_materials",
        }),
      );
    }

    // Add Order Table sheet (Thống kê từng bàn)
    if (data_order_table.data && data_order_table.data.length > 0) {
      const orderTableData = formatData(data_order_table.data, [
        {
          header: this.props.intl.formatMessage({ id: "analytics.export.stt" }),
          key: "stt",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.table",
          }),
          key: "label",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.order_count",
          }),
          key: "count",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.revenue",
          }),
          key: "price",
        },
        {
          header: this.props.intl.formatMessage({
            id: "analytics.export.discount",
          }),
          key: "discount",
        },
      ]);
      const ws10 = XLSX.utils.json_to_sheet(orderTableData);
      XLSX.utils.book_append_sheet(
        wb,
        ws10,
        this.props.intl.formatMessage({
          id: "analytics.dashboards.order-table",
        }),
      );
    }

    // Add Stock Status sheet (Thống kê nguyên vật liệu)
    if (data_stock.data && data_stock.data.length > 0) {
      // Get unit name helper
      const getUnitName = (unitId) => {
        const unit = stocks.data?.find((u) => u.id === unitId);
        return unit ? unit.name : "";
      };

      const stockStatusData = data_stock.data.map((item, idx) => ({
        STT: idx + 1,
        [this.props.intl.formatMessage({ id: "analytics.export.material" })]:
          item.name,
        [this.props.intl.formatMessage({ id: "analytics.export.stock" })]:
          item.count,
        [this.props.intl.formatMessage({ id: "analytics.export.unit" })]:
          getUnitName(item.unit_id),
        [this.props.intl.formatMessage({ id: "analytics.export.min_stock" })]:
          item.minStock || 0,
      }));
      const ws11 = XLSX.utils.json_to_sheet(stockStatusData);
      XLSX.utils.book_append_sheet(
        wb,
        ws11,
        this.props.intl.formatMessage({ id: "analytics.tabs.materials" }),
      );
    }

    // Add Booking sheet (Thống kê đặt bàn) - Only for cafe/restaurant
    const businessType = localStorage.getItem("businessType");
    const { data_booking } = this.state;
    if (
      (businessType === "cafe" || businessType === "restaurant") &&
      data_booking.data &&
      data_booking.data.length > 0
    ) {
      const bookingData = data_booking.data.map((item, idx) => ({
        STT: idx + 1,
        [this.props.intl.formatMessage({ id: "analytics.export.date" })]:
          item.booking_date,
        [this.props.intl.formatMessage({ id: "analytics.export.time" })]:
          item.booking_time?.substring(0, 5),
        [this.props.intl.formatMessage({ id: "analytics.export.customer" })]:
          item.customer_name,
        [this.props.intl.formatMessage({ id: "analytics.export.phone" })]:
          item.customer_phone,
        [this.props.intl.formatMessage({ id: "analytics.export.party_size" })]:
          item.party_size,
        [this.props.intl.formatMessage({ id: "analytics.export.status" })]:
          item.status_display,
        [this.props.intl.formatMessage({ id: "analytics.export.source" })]:
          item.source_display,
      }));
      const ws12 = XLSX.utils.json_to_sheet(bookingData);
      XLSX.utils.book_append_sheet(
        wb,
        ws12,
        this.props.intl.formatMessage({ id: "analytics.export.sheet.booking" }),
      );
    }

    // Generate filename with date range
    const dateStr = setting.all
      ? "tat-ca"
      : `${moment(setting.date_start).format("YYYY-MM-DD")}_${moment(
          setting.date_end,
        ).format("YYYY-MM-DD")}`;
    const fileName = `bao-cao-thong-ke_${dateStr}.xlsx`;

    // Write and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, fileName);

    NotificatioSucController(
      this.props.intl.formatMessage({ id: "analytics.export.success" }),
    );
  };
  /** End Func */

  render() {
    const {
      setting,
      data_outcome,
      data_income,
      data_order_payment,
      data_stock_log,
      data_debt,
      data_make_product,
      data_order_table,
      data_payment_method,
      data_top_products,
      data_top_selling_products,
      data_customer,
      data_staff,
      data_booking,
      data_log,
      data_stock,
      data_chart,
      data_companies,
      stocks,
      products,
      hide_button_add,
      data_pnl_details,
      selectedBuyerProduct,
    } = this.state;

    // Check businessType for booking display
    const businessType = localStorage.getItem("businessType");
    const showBookingAnalytics =
      businessType === "cafe" || businessType === "restaurant";
    const customerSummary = data_customer.summary || {};
    const isCustomerSummaryLoading = data_customer.loading;
    const customerAvgSpent =
      (customerSummary.total_customers || 0) > 0
        ? Math.round(
            (customerSummary.total_spent || 0) /
              (customerSummary.total_customers || 1),
          )
        : 0;

    // console.log('data_companies: ', data_companies);

    return (
      <div className="disable-text-selection">
        {data_companies.loading ? null : (
          <Heading
            onChangeSetting={this.onChangeSetting}
            onToggleSetting={this.onToggleSetting}
            onChangeDate={this.onChangeDate}
            onChangeCompanies={this.onChangeCompanies}
            onExportExcel={this.onExportExcel}
            data_companies={data_companies}
            setting={setting}
            hide_button_add={hide_button_add}
          />
        )}

        {/* Tab Navigation */}
        <Row className="mb-3 tour-tab-analytics">
          <Colxx lg="12">
            <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
              {[
                {
                  key: "overview",
                  label: <IntlMessages id="analytics.tabs.overview" />,
                },
                {
                  key: "products",
                  label: <IntlMessages id="analytics.tabs.products" />,
                },
                {
                  key: "materials",
                  label: <IntlMessages id="analytics.tabs.materials" />,
                },
                {
                  key: "customers",
                  label: <IntlMessages id="analytics.tabs.customers" />,
                },
                {
                  key: "staff",
                  label: <IntlMessages id="analytics.tabs.staff" />,
                },
                {
                  key: "debt",
                  label: <IntlMessages id="analytics.tabs.debt" />,
                },
                {
                  key: "payment",
                  label: <IntlMessages id="analytics.tabs.payment" />,
                },
                {
                  key: "other",
                  label: <IntlMessages id="analytics.tabs.other" />,
                },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => this.setState({ activeTab: tab.key })}
                  style={{
                    flex: tab.key === "overview" ? 2 : 1,
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor:
                      this.state.activeTab === tab.key ? "#145388" : "#e9ecef",
                    color: this.state.activeTab === tab.key ? "white" : "#333",
                    cursor: "pointer",
                    fontWeight:
                      this.state.activeTab === tab.key ? "bold" : "normal",
                    transition: "all 0.2s ease",
                    textAlign: "center",
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </Colxx>
        </Row>

        {/* Tab Content */}
        {this.state.activeTab === "overview" && (
          <>
            {data_outcome.loading ||
            data_income.loading ||
            data_order_payment.loading ||
            data_order_table.loading ? (
              <Row>
                <Colxx lg="12" xl="12" className="mb-4">
                  <Card className="h-100 dashboard-list-with-thumbs-lg">
                    <CardBody>
                      <ContentMini />
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            ) : (
              <TotalCount
                all={setting.all}
                stocks={stocks}
                products={products}
                data_outcome={data_outcome}
                data_income={data_income}
                data_order_table={data_order_table}
                data_order_payment={data_order_payment}
                data_make_product={data_make_product}
                data_pnl_details={data_pnl_details}
              />
            )}

            <Row>
              <Colxx lg="12" xl="8" className="mb-4">
                {data_chart.loading ? (
                  <Card className="h-100 dashboard-list-with-thumbs-lg">
                    <CardBody>
                      <ContentMini />
                    </CardBody>
                  </Card>
                ) : (
                  <SalesChartCard license={true} lineChartData={data_chart} />
                )}
              </Colxx>
              <Colxx lg="12" xl="4" className="mb-4">
                {data_log.loading ? (
                  <Card className="h-100 dashboard-list-with-thumbs-lg">
                    <CardBody>
                      <ContentMini />
                    </CardBody>
                  </Card>
                ) : (
                  <Logs data={data_log.data} />
                )}
              </Colxx>
            </Row>

            <Row>
              {/* OUTCOME */}
              <Colxx lg="12" xl="6" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_outcome"),
                  })}
                >
                  <CardBody>
                    {data_outcome.loading ? (
                      <ContentMini />
                    ) : (
                      <OutcomeTable
                        setting={setting}
                        title={
                          <IntlMessages id="analytics.dashboards.outcome" />
                        }
                        data={data_outcome.data}
                        total_count={data_outcome.total_count}
                        total_price={data_outcome.total_price}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>

              {/* INCOME */}
              <Colxx lg="12" xl="6" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_income"),
                  })}
                >
                  <CardBody>
                    {data_income.loading ? (
                      <ContentMini />
                    ) : (
                      <IncomeTable
                        setting={setting}
                        title={
                          <IntlMessages id="analytics.dashboards.income" />
                        }
                        data={data_income.data}
                        total_count={data_income.total_count}
                        total_price={data_income.total_price}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </>
        )}

        {/* PRODUCTS TAB */}
        {this.state.activeTab === "products" && (
          <>
            {/* Products Summary Cards */}
            <Row className="mb-3">
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_top_selling_products.summary?.total_products_sold || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_products_sold_period" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#17a2b8",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_top_selling_products.summary?.total_quantity_sold || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_quantity_sold_period" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_top_selling_products.summary?.total_revenue || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.product_revenue_period" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#6c757d",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_top_selling_products.summary?.total_cost || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.product_cost_period" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor:
                      (data_top_selling_products.summary?.total_gross_profit || 0) >= 0
                        ? "#20a8d8"
                        : "#dc3545",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_top_selling_products.summary?.total_gross_profit || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.product_gross_profit_period" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor:
                      data_top_selling_products.summary?.avg_profit_margin >= 30
                        ? "#28a745"
                        : data_top_selling_products.summary
                              ?.avg_profit_margin >= 20
                          ? "#ffc107"
                          : "#dc3545",
                    color:
                      data_top_selling_products.summary?.avg_profit_margin >=
                        20 &&
                      data_top_selling_products.summary?.avg_profit_margin < 30
                        ? "#000"
                        : "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {data_top_selling_products.summary?.avg_profit_margin || 0}%
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.product_margin_period" />
                  </small>
                </div>
              </Colxx>
            </Row>
            <Row>
              {/* TOP PRODUCTS - BEST SELLING */}
              <Colxx lg="6" xl="6" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_order_payment"),
                  })}
                >
                  <CardBody>
                    {data_top_selling_products.loading ? (
                      <ContentMini />
                    ) : (
                      <TopProductsTable
                        setting={setting}
                        title={
                          <IntlMessages id="analytics.table.top_selling" />
                        }
                        data={data_top_selling_products.data}
                        total_count={data_top_selling_products.total_count}
                        total_price={data_top_selling_products.total_price}
                        onProductSelect={this.openProductCustomers}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>
              {/* TOP PRODUCTS - SLOWEST SELLING */}
              <Colxx lg="6" xl="6" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_order_payment"),
                  })}
                >
                  <CardBody>
                    {data_top_products.loading ? (
                      <ContentMini />
                    ) : (
                      <TopProductsTable
                        setting={setting}
                        title={<IntlMessages id="analytics.table.top_slow" />}
                        data={data_top_products.data}
                        total_count={data_top_products.total_count}
                        total_price={data_top_products.total_price}
                        onProductSelect={this.openProductCustomers}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </>
        )}

        {/* MATERIALS TAB */}
        {this.state.activeTab === "materials" && (
          <>
            {/* Materials Summary Cards */}
            <Row className="mb-3">
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {data_stock_log.summary?.total_materials || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_materials" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor:
                      data_stock_log.summary?.low_stock_under_10 > 0 ||
                      data_stock_log.summary?.low_stock_under_20 > 0
                        ? "#dc3545"
                        : "#28a745",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    <span style={{ color: "#ffc107" }}>
                      {data_stock_log.summary?.low_stock_under_20 || 0}
                    </span>
                    <span style={{ margin: "0 8px" }}>|</span>
                    <span>
                      {data_stock_log.summary?.low_stock_under_10 || 0}
                    </span>
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.low_stock" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor:
                      data_stock_log.summary?.unassigned_materials > 0
                        ? "#ffc107"
                        : "#6c757d",
                    color:
                      data_stock_log.summary?.unassigned_materials > 0
                        ? "#000"
                        : "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {data_stock_log.summary?.unassigned_materials || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.unassigned_materials" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#17a2b8",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_stock_log.summary?.total_inventory_value || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_inventory_value" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(data_stock_log.summary?.import_value || 0)}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.import_value" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#6f42c1",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {data_stock_log.summary?.import_count || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.import_count" />
                  </small>
                </div>
              </Colxx>
            </Row>
            {/* <Row className='mb-3'>
                    <Colxx xxs='12' sm='6' lg='2' className='mb-2'>
                        <div className='text-center p-3 h-100' style={{
                            backgroundColor: (data_stock_log.summary?.avg_usage_rate || 0) >= 80 ? '#dc3545' : (data_stock_log.summary?.avg_usage_rate || 0) >= 50 ? '#ffc107' : '#28a745',
                            color: (data_stock_log.summary?.avg_usage_rate || 0) >= 50 && (data_stock_log.summary?.avg_usage_rate || 0) < 80 ? '#000' : 'white',
                            borderRadius: '15px'
                        }}>
                            <h2 className='mb-0'>{data_stock_log.summary?.avg_usage_rate || 0}%</h2>
                            <small>Tỷ lệ sử dụng TB</small>
                        </div>
                    </Colxx>
                </Row> */}
            <Row>
              {/* STOCK LOG */}
              <Colxx lg="12" xl="6" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_stock_logs"),
                  })}
                >
                  <CardBody>
                    {data_stock_log.loading ? (
                      <ContentMini />
                    ) : (
                      <StockLogTable
                        setting={setting}
                        title={
                          <IntlMessages id="analytics.dashboards.stock-log" />
                        }
                        data={data_stock_log.data}
                        total_price={data_stock_log.total_price}
                        summary={data_stock_log.summary}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>

              {/* MAKE PRODUCT */}
              <Colxx lg="12" xl="6" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_make_product"),
                  })}
                >
                  <CardBody>
                    {data_make_product.loading ? (
                      <ContentMini />
                    ) : (
                      <MakeProductTable
                        setting={setting}
                        title={
                          <IntlMessages id="analytics.dashboards.make-product" />
                        }
                        data={data_make_product.data}
                        total_price={data_make_product.total_price}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>

              {/* STOCK STATUS */}
              <Colxx lg="12" xl="12" className="mb-4">
                {data_stock.loading ? (
                  <Card className="h-100 dashboard-list-with-thumbs-lg">
                    <CardBody>
                      <ContentMini />
                    </CardBody>
                  </Card>
                ) : (
                  <StockStatus items={data_stock.data} unit={stocks.data} />
                )}
              </Colxx>
            </Row>
          </>
        )}

        {/* CUSTOMERS TAB */}
        {this.state.activeTab === "customers" && (
          <>
            {/* Customer Summary Cards */}
            <Row className="mb-3">
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 text-white h-100"
                  style={{ backgroundColor: "#007bff", borderRadius: "15px" }}
                >
                  <h2 className="mb-0">
                    {isCustomerSummaryLoading
                      ? "..."
                      : customerSummary.total_new || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_new_customers" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 text-white h-100"
                  style={{ backgroundColor: "#17a2b8", borderRadius: "15px" }}
                >
                  <h2 className="mb-0">
                    {isCustomerSummaryLoading
                      ? "..."
                      : customerSummary.total_returning || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_returning_customers" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="3" className="mb-2">
                <div
                  className="text-center p-3 text-white h-100"
                  style={{ backgroundColor: "#28a745", borderRadius: "15px" }}
                >
                  <h2 className="mb-0">
                    {isCustomerSummaryLoading
                      ? "..."
                      : AddCommaNumber(customerSummary.total_spent || 0)}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_spent" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="3" className="mb-2">
                <div
                  className="text-center p-3 text-white h-100"
                  style={{ backgroundColor: "#ffc107", borderRadius: "15px" }}
                >
                  <h2 className="mb-0">
                    {isCustomerSummaryLoading
                      ? "..."
                      : AddCommaNumber(customerAvgSpent)}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.avg_spent_per_customer" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 text-white h-100"
                  style={{ backgroundColor: "#6c757d", borderRadius: "15px" }}
                >
                  <h2 className="mb-0">
                    {isCustomerSummaryLoading
                      ? "..."
                      : AddCommaNumber(customerSummary.total_debt || 0)}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.customer_debt" />
                  </small>
                </div>
              </Colxx>
            </Row>
            <Row>
              {/* CUSTOMER ANALYTICS */}
              <Colxx lg="12" xl="12" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_income"),
                  })}
                >
                  <CardBody>
                    {data_customer.loading ? (
                      <ContentMini />
                    ) : (
                      <CustomerAnalytics
                        setting={setting}
                        new_customers={data_customer.new_customers}
                        returning_customers={data_customer.returning_customers}
                        top_spenders={data_customer.top_spenders}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </>
        )}

        {/* STAFF TAB */}
        {this.state.activeTab === "staff" && (
          <>
            {/* Staff Summary Cards - ALL TIME */}
            <Row className="mb-3">
              <Colxx xxs="12" sm="6" lg="4" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_staff.all_time_summary?.total_sales || 0,
                    )}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_sales" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {data_staff.all_time_summary?.total_bill_count || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_bills" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#6c757d",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {data_staff.all_time_summary?.total_product_count || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.total_items" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 h-100"
                  style={{
                    backgroundColor: "#17a2b8",
                    color: "white",
                    borderRadius: "15px",
                  }}
                >
                  <h2 className="mb-0">
                    {AddCommaNumber(
                      data_staff.all_time_summary?.avg_revenue_per_hour || 0,
                    )}
                    /h
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.avg_revenue_per_hour" />
                  </small>
                </div>
              </Colxx>
              <Colxx xxs="12" sm="6" lg="2" className="mb-2">
                <div
                  className="text-center p-3 text-white h-100"
                  style={{ backgroundColor: "#6c757d", borderRadius: "15px" }}
                >
                  <h2 className="mb-0">
                    {data_staff.all_time_summary?.active_staff_count || 0}/
                    {data_staff.all_time_summary?.total_staff_count || 0}
                  </h2>
                  <small>
                    <IntlMessages id="analytics.summary.active_staff" />
                  </small>
                </div>
              </Colxx>
            </Row>
            <Row>
              {/* STAFF ANALYTICS */}
              <Colxx lg="12" xl="12" className="mb-4">
                <Card className="h-100">
                  <CardBody>
                    {data_staff.loading ? (
                      <ContentMini />
                    ) : (
                      <StaffAnalytics
                        setting={setting}
                        summary={data_staff.summary}
                        data={data_staff.data}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </>
        )}

        {/* DEBT TAB */}
        {this.state.activeTab === "debt" && (
          <Row>
            {/* DEBT */}
            <Colxx lg="12" xl="12" className="mb-4">
              <Card
                className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                  disable: !isRorRBDorRC("analytics_debt"),
                })}
              >
                <CardBody>
                  {data_debt.loading ? (
                    <ContentMini />
                  ) : (
                    <DebtTable
                      setting={setting}
                      title={<IntlMessages id="analytics.dashboards.debt" />}
                      data={data_debt.data}
                      total_count={data_debt.total_count}
                      total_price_income={data_debt.total_price_income}
                      total_price_pending={data_debt.total_price_pending}
                    />
                  )}
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        )}

        {/* PAYMENT TAB */}
        {this.state.activeTab === "payment" && (
          <Row>
            {/* PAYMENT METHOD */}
            <Colxx lg="12" xl="12" className="mb-4">
              <Card
                className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                  disable: !isRorRBDorRC("analytics_income"),
                })}
              >
                <CardBody>
                  {data_payment_method.loading ? (
                    <ContentMini />
                  ) : (
                    <PaymentMethodTable
                      setting={setting}
                      title={
                        <IntlMessages id="analytics.table.payment_method" />
                      }
                      data={data_payment_method.data}
                      total_count={data_payment_method.total_count}
                      total_product_count={
                        data_payment_method.total_product_count
                      }
                      total_price={data_payment_method.total_price}
                    />
                  )}
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        )}

        {/* OTHER TAB */}
        {this.state.activeTab === "other" && (
          <>
            {/* BOOKING ANALYTICS - Only for cafe and restaurant */}
            {showBookingAnalytics && (
              <Row>
                <Colxx lg="12" xl="12" className="mb-4">
                  <Card className="h-100">
                    <CardBody>
                      {data_booking.loading ? (
                        <ContentMini />
                      ) : (
                        <BookingAnalytics
                          data={data_booking}
                          loading={data_booking.loading}
                        />
                      )}
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            )}
            <Row>
              {/* ORDER TABLE - Table Statistics */}
              <Colxx lg="12" xl="12" className="mb-4">
                <Card
                  className={classnames("h-100 dashboard-list-with-thumbs-lg", {
                    disable: !isRorRBDorRC("analytics_table"),
                  })}
                >
                  <CardBody>
                    {data_order_table.loading ? (
                      <ContentMini />
                    ) : (
                      <OrderTable
                        setting={setting}
                        title={
                          <IntlMessages id="analytics.dashboards.order-table" />
                        }
                        data={data_order_table.data}
                        total_count={data_order_table.total_count}
                        total_gift_count={data_order_table.total_gift_count}
                        total_price={data_order_table.total_price}
                        total_discount={data_order_table.total_discount}
                      />
                    )}
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </>
        )}
        <ProductCustomerDrawer
          product={selectedBuyerProduct}
          setting={setting}
          companyUuid={data_companies.selected}
          onClose={this.closeProductCustomers}
        />
      </div>
    );
  }
}

export default injectIntl(ContentComponent);
